/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Body_upload_file } from '../models/Body_upload_file';
import type { DownloadRequest } from '../models/DownloadRequest';
import type { DownloadResponse } from '../models/DownloadResponse';
import type { MetaResponse } from '../models/MetaResponse';
import type { OneDriveFilesResponse } from '../models/OneDriveFilesResponse';
import type { UnselectResponse } from '../models/UnselectResponse';
import type { UploadResponse } from '../models/UploadResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FilesService {
    /**
     * List Onedrive Files
     * OneDriveの任意フォルダ内のファイル一覧を取得するエンドポイント
     * @param folderPath
     * @returns OneDriveFilesResponse Successful Response
     * @throws ApiError
     */
    public static listOnedriveFiles(
        folderPath: (string | null),
    ): CancelablePromise<OneDriveFilesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/onedrive/files/{folder_path}',
            path: {
                'folder_path': folderPath,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Download Onedrive File
     * OneDrive上のファイルをローカルに保存し、
     * セッションにメタ情報を保存するエンドポイント
     * @param requestBody
     * @returns DownloadResponse Successful Response
     * @throws ApiError
     */
    public static downloadOnedriveFile(
        requestBody: DownloadRequest,
    ): CancelablePromise<DownloadResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/onedrive/download',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Upload File
     * クライアントからアップロードされたファイルを、
     * /storage/files/に保存し、セッションにメタ情報を保存するエンドポイント
     * @param formData
     * @returns UploadResponse Successful Response
     * @throws ApiError
     */
    public static uploadFile(
        formData: Body_upload_file,
    ): CancelablePromise<UploadResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/files/upload',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Files Meta
     * セッションに保存されたファイルのメタ情報を返すエンドポイント
     * @returns MetaResponse Successful Response
     * @throws ApiError
     */
    public static selectedFiles(): CancelablePromise<MetaResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/files/selected',
        });
    }
    /**
     * Overwrite Selected
     * セッションに保存されたファイルを書き込む
     * @returns UnselectResponse Successful Response
     * @throws ApiError
     */
    public static overwriteSelectedFile(): CancelablePromise<UnselectResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/files/selected',
        });
    }
    /**
     * Unselect File
     * セッションに保存されたファイルのメタ情報を削除するエンドポイント
     * @returns UnselectResponse Successful Response
     * @throws ApiError
     */
    public static unselect(): CancelablePromise<UnselectResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/files/selected',
        });
    }
}
